import NeoFlashZoomedPictureDialog from "../../dialogs/flashScreen/NeoFlashZoomedPictureDialog";
import SystemCustomDivider from "../../dividers/SystemCustomDivider";
import {isNullOrUndefined} from "../../../services/Validator";
import {MathJax, MathJaxContext} from "better-react-mathjax";
import NeoFlashQuestionPicture from "./NeoFlashQuestionPicture";
import {useState} from "react";
import {get_nested} from "../../../services/JsonHandler";

export default function NeoFlashQuestion({question}) {
    // Used in NeoFlashCoreContent to display Question statement
    // related content in a whole block

    // PROPERTIES
    const [isPictureModalOpen, setIsPictureModalOpen] = useState(false)
    const statement = get_nested(['query'], question, null)
    const pictureUrl = get_nested(['questionPicture', 'filePath'], question, null)

    // BUILD
    return (
        <div className={"w-3/5 h-[360px] min-h-[360px] bg-primaryDark7/30 border-[1px] border-greyLight1 flex flex-col justify-start items-start px-[16px] pt-[12px] pb-[16px] rounded-[12px]"}>
            {/** MODAL */}
            <NeoFlashZoomedPictureDialog open={isPictureModalOpen}
                                         handleClose={() => setIsPictureModalOpen(false)}
                                         pictureUrl={pictureUrl} />
            {/** CONTENT */}
            <div className={"w-full flex justify-center items-center"}>
                <span className={"text-[14px] font-medium text-greyLight5"}>
                    {"Énoncé"}
                </span>
            </div>
            <SystemCustomDivider color={"bg-greyLight3"} extraClass={"mt-[12px]"} />
            <div className={`w-full flex ${isNullOrUndefined(pictureUrl) ? "h-full flex-col justify-center -mt-[12px]" : "justify-start mt-[12px]"} items-center px-[12px] text-center`}>
                <MathJaxContext>
                    <MathJax inline dynamic>
                        <span className="whitespace-pre-line font-bold text-[18px] text-white">
                            {statement}
                        </span>
                    </MathJax>
                </MathJaxContext>
            </div>
            <NeoFlashQuestionPicture pictureUrl={pictureUrl}
                                     openZoom={() => setIsPictureModalOpen(true)} />
        </div>
    );
}